import {action, observable, runInAction} from 'mobx'
import {json} from "../../../utils/ajax";
import {message} from 'antd'
import {
    clearForm,
    getReplyList,
    handleSearchAndPage,
    objToValueObj,
    setStore,
    ValueObjToObj
} from "../../../utils/Utils";
import BraftEditor from "braft-editor";
import moment from "moment/moment";


class frontAnswerCenterStore {
    @observable list //表格数据
    @observable pagination //表格分页
    @observable searchField //表单搜索绑值
    @observable carseriesNameList //下拉框车系
    @observable formatMessage //国际化
    @observable assessVisible //评价框
    @observable mainGroupCodeList //主组号
    @observable groupCode //分组号
    @observable selectList //下拉框数据
    @observable loading //下拉框数据
    @observable selectMenu //问题选项卡数据

    /**新增***/
    @observable isShowAddBox //是否显示新增模态框
    @observable addField //新增表单绑值
    @observable confirmLoading //新增按钮loading效果
    @observable editorContent //绑定主题内容
    @observable questionType //选择的问题类型

    /**********主题回复*************/
    @observable reviewLoading //主题回复loading效果
    @observable subjectId //保存当前选中行id
    @observable reviewSubject //保存主题区数据
    @observable isCheck  //是否审核  0审核，1未审核
    @observable isAccept  //是否采纳  0采纳，1未采纳
    @observable replyItem  //显示对应回复文本框
    @observable replyList  //回复数据
    @observable replySubject  //主题发表内容
    @observable fileList //上传文件
    @observable roleOrLoginName //当前用户权限


    @observable editModalVisible //点击编辑按钮
    @observable editEditorValue //修改模态框内容

    @observable notice  //分类
    @observable current  //默认显示栏目
    @observable isDis  //判断是否禁用
    @observable isChangeUrl
    @observable carId
    @observable questionTypeList //问题类型
    @observable addAMGDisabled   //车系是否禁用
    @observable emergencyLevelList  //紧急程度

    constructor() {
        this.notice = []
        this.loading = false
        this.current = '我的'
        this.list = []
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.selectMenu = []
        this.searchField = {
            subject: '', //主题
            carseriesCode: '',//车系
            carseriesName: '', //车系名称
            type: '',
            mainGroupCode: '',
            groupCode: '',
        }
        this.carseriesNameList = []
        this.formatMessage = () => {
        }
        this.assessVisible = false
        this.mainGroupCodeList = []
        this.groupCode = []
        this.selectList = []

        /**新增***/
        this.isShowAddBox = false
        this.addField = {
            id: '',
            subject: '',
            carseriesCode: '',
            vin: '',
            mainGroupCode: '',
            serviceCode: '',
            engineNumber: '',
            contactName: '',
            attachment: '',
            attachmentName: '',
            type: '',
            emergencyLevel: '',
            productionDate: '',
            groupCode: '',
            serviceStation: '',
            transmission: '',
            contactNumber: '',
            description: '',
        }
        this.confirmLoading = false
        this.editorContent = BraftEditor.createEditorState(null)
        this.editEditorValue = {
            commentText: BraftEditor.createEditorState(null)
        }
        this.questionType = ''

        /****主题回复****/
        this.reviewLoading = false
        this.subjectId = ''
        this.reviewSubject = {}
        this.isCheck = ''
        this.isAccept = ''
        this.replyItem = ''
        this.replyList = []
        this.replySubject = {
            subjectId: '',
            pId: '0',
            level: 1,
            id: '',
            senderLogName: '',
            senderUserName: '',
            commentText: '',
            photo: '',
            attachment: '',
            attachmentName: '',
            sort: '',
            commentedUserName: '',
            commentedId: '',
            senderUserPhoto: ''
        }
        this.fileList = []
        this.roleOrLoginName = {}
        this.editModalVisible = false
        this.isDis = false
        this.isChangeUrl = ''
        this.carId = ''
        this.questionTypeList = []
        this.addAMGDisabled = ''
        this.emergencyLevelList = [{id: 1,name: '急'},{id: 2,name: '紧急'}]
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /***搜索表单、列表新增绑值**/
    @action
    onFormField = (changedFields, fields) => {
        const change = ValueObjToObj(changedFields)
        this[fields] = {...this[fields], ...change}
    }


    /***主页面列表数据 ***/
    @action
    initPage = async (page) => {
        this.loading = true
        let searchField = {
            ...this.searchField,
            carseriesName: this.searchField.carseriesName ? this.searchField.carseriesName : '',
            carseriesCode: this.searchField.carseriesCode ? this.searchField.carseriesCode : '',
            type: this.searchField.type ? this.searchField.type : '',
            mainGroupCode: this.searchField.mainGroupCode ? this.searchField.mainGroupCode.split('/')[1] : '',
            groupCode: this.searchField.groupCode ? this.searchField.groupCode : '',
        }
        let search = handleSearchAndPage(page, this.pagination, searchField)
        let res = {}
        if (this.current === '我的') {
            res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/getAnswerCenterPageBefore:search`, search)
        } else if (this.current === '案例') {
            res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/showShare`, search)
        }
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.list = res.content ? res.content : []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
        })
    }

    /**案例选项卡***/
    @action
    selectSubModel = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/selectSubModel`)
        runInAction(() => {
            this.selectMenu = Array.isArray(res) ? res : []
        })
    }

    /***搜索框车系数据 ***/
    @action
    initCarseries = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/moduleNameQueryCarSeriesTable/${this.questionType}`)
        runInAction(() => {
            this.carseriesNameList = Array.isArray(res) ? res : []
        })
    }

    /***搜索框下拉数据 ***/
    @action
    initAddSelect = async () => {
        // const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/ansawerCenter/selectData`)
        // runInAction(() => {
        //     this.selectList = Array.isArray(res) ? res : []
        // })
    }

    /***问题类型**/
    @action
    getQuestionType = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/dictionary/getOneRoot`, {name: '问题类型/'})
        runInAction(()=> {
            this.questionTypeList = Array.isArray(res.children) ? res.children : []
        })
    }

    /***重置**/
    @action
    handleReset = () => {
        this.searchField = clearForm(this.searchField)
        this.mainGroupCodeList = []
        this.groupCode = []
        this.initPage()
    }

    /***评价***/
    @action
    showAssessModal = (record) => {
        this.assessId = record
        this.assessVisible = true
    }

    @action
    saveAssess = async (value, text) => {
        let obj = {
            id: this.assessId.id,
            assess: value ? value : '',
            reason: text ? text : ''
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/assess`, obj)
        if (res.status === 1) {
            runInAction(() => {
                    message.success('评价成功')
                    this.assessVisible = false
                }
            )
        }
        runInAction(() => {
            // message.success('评价成功')
            this.assessVisible = false
        })
        this.initPage(this.pagination.current)
    }


    /****根据车系选择主组号***/
    @action
    getMainGroupCode = async (value) => {
        const carseriesCode = value.split("+")[0]&&value.split("+")[0] !== 'undefined'?value.split("+")[0]:''
        this.carId = value.split("+")[1]
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/directory?carseriesCode=${carseriesCode}`)
        runInAction(() => {
            this.mainGroupCodeList = Array.isArray(res) ? res : []
        })
    }

    /****根据主组号选择分组号***/
    @action
    getGroupCode = async (carseriesCode, values) => {
        const id = values.split('/')[0]
        const carCode = carseriesCode.split('+')[0]
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/queryLvThreeCatalogs/carseriesCode?carseriesCode=${carCode}&lv2Id=${id}`)
        runInAction(() => {
            this.groupCode = Array.isArray(res) ? res : []
        })
    }

    /********************新增***************************************/
    /***新增表单**/
    @action
    onAddFormField = (changedFields, fields) => {
        this[fields] = {...this[fields], ...changedFields}
    }

    @action
    showAddBox = () => {
        this.initAddSelect()
        this.isShowAddBox = true
        this.isDis = false
        this.addField = clearForm(this.addField)
        this.selectList1 = objToValueObj(this.selectList[2])
        this.addField = {
            ...this.addField,
            serviceStation: this.selectList.length > 0 ? this.selectList1[0] : '',
            serviceCode: this.selectList.length > 0 ? this.selectList1[1] : ''
        }
        this.editorContent = BraftEditor.createEditorState(null)
    }

    /**新增主题***/
    @action
    addSubject = async (values) => {
        this.confirmLoading = true
        let addField = {
            ...values,
            carseriesCode: values.carseriesCode.split("+")[0],
            description: this.editorContent.toHTML(),
            carseriesId: this.carId,
            attachment: this.addField.attachment ? this.addField.attachment : '',
            attachmentName: this.addField.attachmentName ? this.addField.attachmentName : '',
            productionDate: this.addField.productionDate && this.addField.productionDate.value ? moment(this.addField.productionDate.value).format("YYYY-MM-DD") : "",
            mainGroupCode: values.mainGroupCode && values.mainGroupCode.split('/')[1] ? values.mainGroupCode.split('/')[1] : values.mainGroupCode,
            id: this.addField.id ? this.addField.id.value : '',
            // mainGroupCode:values.mainGroupCode?values.mainGroupCode:'',
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/addAnswerCenter`, addField)
        if (!res.status) {
            runInAction(() => {
                this.confirmLoading = false
                this.mainGroupCodeList = []
            })
        } else {
            message.success(this.formatMessage({id: 'answer.addSuccessfully'}))
            runInAction(() => {
                this.confirmLoading = false
                this.isShowAddBox = false
                this.mainGroupCodeList = []
            })
            this.initPage(this.pagination.current)
        }
    }

    /********************主题回复**************************************************************************/
    /***页面初始化***/
    @action
    initReviewData = async () => {
        this.reviewLoading = true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/showAnswerCenter/${this.subjectId}`)   //获取主题区数据
        const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenterComment/getTree?subjectId=${this.subjectId}&frontOrBack=front`)  //获取回复树数据
        // const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenterComment/getTree?subjectId=${this.subjectId}`)  //获取回复树数据
        let replyList = []
        if (res1.status === 0) {
            return
        }
        res1 && res1.forEach(item => {
            const obj = {...item, list: []}
            getReplyList(item.children, obj.list, item.senderUserName)
            replyList.push(obj)
        })
        runInAction(() => {
            this.reviewSubject = res
            this.replyList = replyList
            this.isCheck = res.isCheck
            this.isAccept = res.isAccept
            this.replySubject = {
                ...this.replySubject,
                subjectId: this.subjectId,
                commentedId: this.subjectId,
                commentedUserName: res.postUserName
            }
            this.reviewLoading = false
            this.roleOrLoginName = JSON.parse(localStorage.getItem('status'))
        })
    }

    /***删除回复**/
    @action
    deleteReplay = async (id) => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenterComment/delCommentByCommentId/${id}`)
        if (!res.status) {
            return
        }
        message.success('删除成功')
        this.initReviewData(this.subjectId)
    }


    /**采纳***/
    @action
    setAccept = async (commentId, subjectId) => {
        this.reviewLoading = true
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/commentId/${commentId}/id/${subjectId}`)
        runInAction(() => {
            this.isAccept = 1
            this.replyItem = ''
            this.reviewLoading = false
        })
        message.success('已采纳！')
        this.initReviewData(this.subjectId)
    }

    /***回复replyWho=''/  发布replyWho='replySubject' ***/
    @action
    replyContent = async (comment) => {
        this.reviewLoading = true
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenterComment/add`, comment)
        runInAction(() => {
            this.replyItem = ''
            this.reviewLoading = false
            this.replySubject = {
                attachment: '',
                attachmentName: ''
            }
        })
        this.initReviewData(this.subjectId)
    }


    /**编辑某一主题的回复***/
    @action
    editEditor = async () => {
        this.confirmLoading = true
        this.loading = true
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenterComment/edit`, this.editEditorValue)
        runInAction(() => {
            this.editEditorValue = {}
            this.editModalVisible = false
            this.confirmLoading = false
            this.loading = false
        })
        message.success('编辑成功')
        this.initReviewData(this.subjectId)
    }

    @action
    checkVin = async (value) => {
        let vin = {"vin": value}
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/addAnswerCenter/checkvin`, vin);
        if (res.code === "500") {
            message.error('VIN不存在')
            runInAction(() => {
                this.addField = {...this.addField, ...{"vin": ''}}
            })
        }

    }

    @action
    updateAddBox = async (id) => {
        this.isDis = true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/showAnswerCenter/${id}`)
        let attachment = res.attachment
        let attachmentName = res.attachmentName
        let description = res.description
        runInAction(() => {
            this.addField = {...this.addField, ...objToValueObj(res)}
            this.editorContent = BraftEditor.createEditorState(description)
            this.addField = {
                ...this.addField, ...{
                    productionDate: {value: res.productionDate ? moment(res.productionDate) : null},
                    attachmentName: attachmentName,
                    attachment: attachment
                }
            }
            this.isShowAddBox = true
        })
    }

    @action
    commitData = async (id) => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/commitAnswerCenter/${id}`)
        runInAction(() => {
            if (res.status === 1) {
                message.success('提交成功！')
                this.initPage()
            } else {
                message.warn('提交失败')
                return
            }
        })
    }

}

export default new frontAnswerCenterStore()



// WEBPACK FOOTER //
// ./src/project/dongfeng/AnswerCenter/store.js